/* eslint-disable import/order */
import React from 'react';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getBusinessProjectResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { licenseDetailsResource_DEPRECATED_DO_NOT_USE } from '@jira/router-resources__business-license-details/src/useIsPremiumUserSeat.tsx';
import type SoftwareNotificationsSettingsType from '@jira/spa-apps__project-settings-software-notifications/src/ProjectSettingsSoftwareNotifications.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { coreProjectLayout } from '@jira/platform__layouts-core-project-layout/src/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { projectSettingsCoreNotificationsRoute } from '@jira/router-routes__project-settings-core-routes/src/projectSettingsCoreNotificationsRoute.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { getNavigationSidebarProjectSettingsResource } from './common/getNavigationSidebarProjectSettingsResource.tsx';
import type { Route } from '@atlassian/react-resource-router';

const LazyNotificationsSettings = lazyForPaint<typeof SoftwareNotificationsSettingsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-core-notifications", jiraSpaEntry: "async-project-settings-software-notifications" */ '@jira/spa-apps__project-settings-software-notifications/src/ProjectSettingsSoftwareNotifications.tsx'
		),
	),
);

const Notifications = () => (
	<LazyPage
		Page={LazyNotificationsSettings}
		pageId="project-settings-software-notifications"
		shouldShowSpinner={false}
	/>
);

export const projectSettingsCoreNotificationsRouteEntry: Route = createEntry(
	projectSettingsCoreNotificationsRoute,
	() => ({
		group: 'project-settings-core',

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		layout: coreProjectLayout,

		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			...getNavigationSidebarProjectSettingsResource(),
			...getBusinessProjectResources(),
			licenseDetailsResource_DEPRECATED_DO_NOT_USE,
		],

		// eslint-disable-next-line no-restricted-syntax
		component: Notifications,
		forPaint: [LazyAtlassianNavigation, LazyNotificationsSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
